module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/smarthouse-56954779c3094d919b9ebb615d6f6524.jpg";